import React from "react";
import { Modal, Tab, Nav, NavItem } from "react-bootstrap";
import { Images } from "../components";
import { MyContext } from "../context";

const prizeTabs = [
  {
    key: "digital-world-cup",
    title: "Digital World Cup",
    sections: [
      {
        heading: "The Journey",
        prizes: [
          {
            label: "Champion",
            value: "$1,000,000 + Gold medal + Trophy",
            highlight: true
          },
          {
            label: "Second (2nd)",
            value: "$500,000 + Silver medal",
            highlight: true
          },
          {
            label: "Third (3rd)",
            value: "$250,000 + Bronze medal",
            highlight: true
          },
          {
            label: "Semi-final",
            value: "$5,000 each"
          },
          {
            label: "Quarter-final",
            value: "$1,000 each"
          },
          {
            label: "Round-16",
            value: "$500 each"
          },
          {
            label: "Round-32",
            value: "$100 each"
          },
          {
            label: "Ground Stage Qualification",
            value: "$1 each"
          }
        ]
      },
      {
        heading: "Global Ranking",
        prizes: [
          {
            label: "Per Match",
            value: "Player of the Match (PoTM; highest points scorer per match) = $100",
            highlight: true
          },
          {
            label: "Per Round: 1-11th",
            value: "$100 each"
          },
          {
            label: "Per Round: 12-1,000th",
            value: "$10 each"
          },
          {
            label: "Overall Top11: 1-11th",
            value: "$1,000 each"
          },
          {
            label: "Quad3ick",
            value: "Maximum 15 points in a match = $100,000 (shared equally)",
            highlight: true
          },
          {
            label: "C6rrect",
            value: "Correct final results outcomes in 6 matches in a round = $500,000 (shared equally)",
            highlight: true
          },
          {
            label: "MVP",
            value: "Overall best, i.e., 1st on Overall global ranking = $100,000",
            highlight: true
          },
          {
            label: "Overall Best Awards",
            value: "x 12 Outcomes = $10,000 each"
          }
        ]
      }
    ]
  },
  {
    key: "global-series",
    title: "Global Series",
    sections: [
      {
        heading: "Coming soon...",
        prizes: []
      }
    ]
  }
];

export default class PrizeRules extends React.Component {
  renderPrizeList(prizes) {
    return (
      <ul className="scoring-chart prize-chart">
        {prizes.map((item, idx) => {
          return (
            <li key={idx} className={item.highlight ? "featured-prize" : ""}>
              <div className="display-table">
                <div className="text-block">{item.label}</div>
                <div className="value-block">{item.value}</div>
              </div>
            </li>
          );
        })}
      </ul>
    );
  }

  render() {
    const { IsPrizeModalShow, IsPrizeModalHide } = this.props;

    return (
      <MyContext.Consumer>
        {() => (
          <div>
            <Modal
              show={IsPrizeModalShow}
              onHide={IsPrizeModalHide}
              bsSize="large"
              dialogClassName="contest-detail-modal modal-scoring-body"
            >
              <Modal.Header>
                <Modal.Title>
                  <img src={Images.LOGO} alt="" className="vissel-img" />
                  <a
                    href="#close"
                    onClick={(e) => {
                      e.preventDefault();
                      IsPrizeModalHide();
                    }}
                    className="modal-close"
                  >
                    <i className="icon-close" />
                  </a>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ maxHeight: "100vh", overflow: "auto" }}>
                <div className="rules-scoring-body prize-rules-body">
                  <div className="type-heading">Prizes</div>
                  <Tab.Container
                    id="prize-rules-tabs"
                    defaultActiveKey={prizeTabs[0].key}
                  >
                    <div>
                      <div className="custom-nav-tabs tabs-two default-tab default-tab-two">
                        <Nav bsStyle="tabs">
                          {prizeTabs.map(item => (
                            <NavItem eventKey={item.key} key={item.key}>
                              {item.title}
                            </NavItem>
                          ))}
                        </Nav>
                      </div>
                      <Tab.Content animation>
                        {prizeTabs.map(item => (
                          <Tab.Pane eventKey={item.key} key={item.key}>
                            {item.sections.map((section, idx) => (
                              <div key={idx}>
                                <div className="type-heading prize-sub-heading">
                                  {section.heading}
                                </div>
                                {section.prizes.length > 0 && this.renderPrizeList(section.prizes)}
                              </div>
                            ))}
                          </Tab.Pane>
                        ))}
                      </Tab.Content>
                    </div>
                  </Tab.Container>
                </div>
              </Modal.Body>
            </Modal>
          </div>
        )}
      </MyContext.Consumer>
    );
  }
}
